import axios from 'axios'
import { Toast } from 'vant'
import store from '../store/index'
import router from '../router'

// let baseUrl = ''
// if (process.env.VUE_APP_MODE === 'development') {
//   // 开发环境下的执行操作
//   baseUrl = process.env.VUE_APP_API_URL
// } else {
//   // 生产环境下的执行操作
//   baseUrl = process.env.VUE_APP_API_URL
// }

// create an axios instance
console.log(process.env)
// console.log('base_url',window.g.base_url)
const service = axios.create({
  baseURL: window.g.base_url,
  headers: {
    // 'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/x-www-form-urlencoded'
  },
  timeout: 30000
})

// request interceptor // 请求拦截器
service.interceptors.request.use(
  config => {
    Toast.loading({
      mask: false,
      duration: 0, // 一直存在
      forbidClick: true, // 禁止点击
      message: '加载中...'
    })
    if (localStorage.getItem('token') != 'undefined'){
      const token = localStorage.getItem('token')
      // console.log(token)
      if (token != null) {
        // console.log('token 非空')
        token && (config.headers.Authorization = token)
      } else {
        // console.log('token 为空',9999)
      }
    }
    return config
  },
  error => {
    console.log('请求拦截器',error)
    // Promise.reject(error)
    // 请求错误
    Toast.clear()
    // Toast('请求错误，请稍后再试')
    console.log(error)
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
)

// response interceptor // 响应拦截器
// service.interceptors.response.use(
//   response => response,
//   error => {
//     // const { data } = error.response
//     return Promise.reject(error)
//   }
// )
// 响应拦截器
service.interceptors.response.use(res => {
  // 响应成功
  // alert('请求成功啦')
  Toast.clear()
  // console.log(res)
  // return res.data
   if(res.data.code ==401){ // token 过期
      console.log('token 过期')
    store.commit("setToken", ''); // 清除key
    store.commit('setUserInfo', '')
     var url = router.currentRoute.fullPath
     console.log('url',url)
     store.commit("setCurrPageUrl",router.currentRoute.fullPath)
    // this.$router.push('/');
     location.reload()// 为了重新实例化 vue-router 对象，避免 bug
     // router.replace({
     //   name:"/",
     //   query: {redirect: router.currentRoute.fullPath}
     // })

    // router.push('/')

  } else {
    return res.data
  }

}, err => {
  // 响应失败
  console.log('响应超时，请刷新')
  console.log(err)
  Toast.clear()
  // Toast(err.response)
  return Promise.reject(err.response.data); // 返回接口返回的错误信息
})

export default service
